import { createFileRoute } from '@tanstack/react-router'
import { RelatorioCidDias } from '@/features/relatorios-cid-dias'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute(
  '/_authenticated/relatorios/cid-dias/',
)({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: RelatorioCidDias,
})
